import { useAllContactsSource } from 'legacy/lut/components/widgets/public/partnerContacts/components/tabs/allContactsTab/hooks/useAllContactsSource'
import { useEffect, useMemo, useState } from 'react'

import { IContactSearchItem, IPartnerContact } from '../model/types'

interface IParams {
  partnerId: string
  partnerContacts: IPartnerContact[]
  mapContactSearchItem: (item: any, partnerContacts: IPartnerContact[]) => IContactSearchItem
}

export const useContactSearch = ({ partnerId, partnerContacts, mapContactSearchItem }: IParams) => {
  const [searchString, setSearchString] = useState('')
  const [contacts, setContacts] = useState<IContactSearchItem[]>([])

  const { source } = useAllContactsSource({
    partnerId,
  })

  const filteredOptions = useMemo(() => {
    return contacts.filter((contact) => {
      return (
        contact.fullName.toLowerCase().includes(searchString.toLowerCase()) ||
        contact.email.toLowerCase().includes(searchString.toLowerCase())
      )
    })
  }, [searchString, contacts])

  useEffect(() => {
    if (source) {
      source.fetch().then((result) => {
        setContacts(result.items.map((item) => mapContactSearchItem(item, partnerContacts)))
      })
    }
  }, [source, partnerContacts, mapContactSearchItem])

  return {
    searchString,
    setSearchString,
    filteredOptions,
  }
}
